import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Content, DropdownStyle } from './dropdown-style';

function Dropdown(props) {
  const { content, placement, title, action, children, style, className, visible, onVisibleChange, align, open, onOpenChange } = props;

  // Left undefined by default so every existing caller keeps antd's own
  // open/close handling; passing them makes the dropdown controlled.
  return (
    <DropdownStyle
      overlayClassName={className}
      style={style}
      placement={placement}
      title={title}
      overlay={<Content>{content}</Content>}
      trigger={action}
      visible={visible}
      onVisibleChange={onVisibleChange}
      align={align}
      open={open}
      onOpenChange={onOpenChange}
    >
      {children}
    </DropdownStyle>
  );
}

const content = (
  <>
    <Link to="#">
      <span>Export to CSV</span>
    </Link>
    <Link to="#">
      <span>Export to XML</span>
    </Link>
    <Link to="#">
      <span>Export to Drive</span>
    </Link>
  </>
);

Dropdown.defaultProps = {
  action: ['hover'],
  placement: 'bottomRight',
  content,
  style: {},
  className: 'ninjadash-dropdown',
};

Dropdown.propTypes = {
  visible: PropTypes.bool,
  onVisibleChange: PropTypes.func,
  align: PropTypes.object,
  placement: PropTypes.string,
  title: PropTypes.string,
  action: PropTypes.array,
  content: PropTypes.node,
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
};

export { Dropdown };
